module.exports = function (app) {
    app.controller('pages.account.terms-and-conditions', ['$scope',
        function ($scope) {
            $scope.heading = "Terms and Conditions";
        }
    ]);
}